/* eslint-disable quotes */
/* eslint-disable semi */
import { storeGetters } from '@store/getters.constants';

const getters = {
//   [storeGetters.getOrgName]: (state) => {
//     return state.organization_name;
//   },
  [storeGetters.getDesignations]: (state) => {
    console.log(state.designations)
    return state.designations;
  },
//   [storeGetters.getLicenseByid]: (state) => {
//     return state.license;
//   },
//   [storeGetters.getLicenseCount]: (state) => {
//     return state.licenseCount;
//   },
};
export default { ...getters };